import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FuelingContractDetailLayoutPage from './FuelingContractDetailLayoutPage';
import { Fueling_FuelingHistory, Fueling_FuelingTransactionsExport } from 'data/endpoints';
import { QuotationType } from 'features/shared/enums/quotationType';
import { FuelingTransactionViewType } from 'features/fueling/enums/fuelingTransactionViewType';
import MeasuredData from 'features/shared/components/measuredData/MeasuredData';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import FuelingGraphSection from 'features/fueling/sections/FuelingGraphSection';
import { endOfMonth, startOfMonth, sub } from 'date-fns';

type Props = {
  contract: ContractFullDTO;
}

const FuelingContractHistoryPage = ({ contract }: Props) => {
  // translations
  const tModules = useTranslation("shared\\moduleNames").t;
  const tLabels = useTranslation("contracts\\contracts").t;

  // helpers
  const getToDate = () => { 
    let actualDate = new Date();
    return endOfMonth(actualDate);
  }

  const getFromDate = () => { 
    let endOfActualMonth = getToDate();
    return startOfMonth(sub(endOfActualMonth, {months: 4 }));
  }

  // render
  return (
    <FuelingContractDetailLayoutPage
      links={[{ text: tModules("fuelingContractDetail.title") }]}
      showLinkToDetail={false}
    >
      <FuelingGraphSection 
        entityType="Contract"
        entityId={contract.contractId!}
        commodityDetail={contract.commodityDetail!}
        from={getFromDate()}
        to={getToDate()}
        quotationType="Month"
      />
      <MeasuredData 
        title={tLabels("fuelingContractHistoryPage.monthlyData")}
        commodityDetail={contract.commodityDetail!}
        from={contract.effectiveDate!}
        to={contract.terminationDate!}
        graphDataUrl={Fueling_FuelingHistory}
        graphDataParams={getQueryParams("QuotationType", QuotationType.Day)}
        downloadDataUrl={Fueling_FuelingTransactionsExport}
        downloadDataParams={getQueryParams("ViewType", FuelingTransactionViewType.FuelingCard)}
        identificationParams={getQueryParams("ContractId", contract.contractId!)}
      />
    </FuelingContractDetailLayoutPage>
  )
}

export default FuelingContractHistoryPage;